import React from 'react';
import styled from '@emotion/styled';
import { CARD_TYPES, MAX_CREDIT_CARD_ICONS } from '@business/utils/creditcard';
import ScreenSize from '../../constants/screen-sizes';
import { ReactComponent as MasterCardGiantIcon } from '@view/assets/icons/payment/cc_mastercard_giant.svg';
import { ReactComponent as MasterCardIcon } from '@view/assets/icons/payment/cc_mastercard_default.svg';
import { ReactComponent as VisaGiantIcon } from '@view/assets/icons/payment/cc_visa_giant.svg';
import { ReactComponent as VisaIcon } from '@view/assets/icons/payment/cc_visa_default.svg';
import { ReactComponent as AmexGiantIcon } from '@view/assets/icons/payment/cc_amex_giant.svg';
import { ReactComponent as AmexIcon } from '@view/assets/icons/payment/cc_amex_default.svg';
import { ReactComponent as JcbGiantIcon } from '@view/assets/icons/payment/cc_jcb_giant.svg';
import { ReactComponent as JcbIcon } from '@view/assets/icons/payment/cc_jcb_default.svg';
import { ReactComponent as DinersClubGiantIcon } from '@view/assets/icons/payment/cc_dinersclub_giant.svg';
import { ReactComponent as DinersClubIcon } from '@view/assets/icons/payment/cc_dinersclub_default.svg';
import { ReactComponent as DiscoverGiantIcon } from '@view/assets/icons/payment/cc_discover_giant.svg';
import { ReactComponent as DiscoverIcon } from '@view/assets/icons/payment/cc_discover_default.svg';
import { ReactComponent as UnionPayGiantIcon } from '@view/assets/icons/payment/cc_unionpay_giant.svg';
import { ReactComponent as UnionPayIcon } from '@view/assets/icons/payment/cc_unionpay_default.svg';

type CreditCardLogoTileProps = {
  isMobile: boolean;
  supportedCards: CARD_TYPES[];
};

const CreditCardLogoTile = ({
  supportedCards,
  isMobile,
}: CreditCardLogoTileProps) => {
  const cardsToGiantIcons = {
    [CARD_TYPES.VISA]: <VisaGiantIcon />,
    [CARD_TYPES.MASTER_CARD]: <MasterCardGiantIcon />,
    [CARD_TYPES.AMEX]: <AmexGiantIcon />,
    [CARD_TYPES.DINERS_CLUB]: <DinersClubGiantIcon />,
    [CARD_TYPES.DISCOVER]: <DiscoverGiantIcon />,
    [CARD_TYPES.JCB]: <JcbGiantIcon />,
    [CARD_TYPES.UNION_PAY]: <UnionPayGiantIcon />,
  };
  const cardsToMobileIcons = {
    [CARD_TYPES.VISA]: <VisaIcon />,
    [CARD_TYPES.MASTER_CARD]: <MasterCardIcon />,
    [CARD_TYPES.AMEX]: <AmexIcon />,
    [CARD_TYPES.DINERS_CLUB]: <DinersClubIcon />,
    [CARD_TYPES.DISCOVER]: <DiscoverIcon />,
    [CARD_TYPES.JCB]: <JcbIcon />,
    [CARD_TYPES.UNION_PAY]: <UnionPayIcon />,
  };

  const cardsWithIcons: CARD_TYPES[] = Object.keys(
    cardsToGiantIcons
  ) as CARD_TYPES[];

  const supportedCardsWithIcons = supportedCards.filter((code) =>
    cardsWithIcons.includes(code)
  );

  const cardsToShow = supportedCardsWithIcons.slice(0, MAX_CREDIT_CARD_ICONS);
  const surplusCards = supportedCards.filter(
    (card) => !cardsToShow.includes(card)
  );

  return (
    <>
      {cardsToShow.map((code: CARD_TYPES) => {
        return (
          <React.Fragment key={code}>
            {isMobile ? cardsToMobileIcons[code] : cardsToGiantIcons[code]}
            <StyledSpacer />
          </React.Fragment>
        );
      })}
      {!!surplusCards.length && (
        <SurplusCardsContainer isMobile={isMobile}>
          +{surplusCards.length}
        </SurplusCardsContainer>
      )}
    </>
  );
};

export default CreditCardLogoTile;

const SurplusCardsContainer = styled.div<{ isMobile: boolean }>`
  border: 1px solid #99A1AF;
  border-radius: 5px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${({ isMobile }) => (isMobile ? '32px' : '40px')};
`;

const StyledSpacer = styled.div`
  width: 16px;

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    width: 4px;
  }
`;
